export const HeaderCard = ({ children }: { children: React.ReactElement<any, any>[] }) => {
  return (
    <div className="flex flex-col justify-between space-y-[10px] py-[10px]">
      <div className="w-full flex flex-col md:flex-row md:flex-1 space-x-0 md:space-x-[20px] space-y-[20px] md:space-y-0">
        {children}
      </div>
    </div>
  )
}
